import fetchExpresso from 'utility/fetchExpresso';

import type { ReportView, ReportViewConfig, ReportViewVisibility } from './reportViewTypes';

export type CreateReportViewInput = {
    baseReportId: string;
    name: string;
    description?: string | null;
    config: ReportViewConfig;
    visibility?: ReportViewVisibility;
};

export async function createReportView(
    eventId: number,
    input: CreateReportViewInput,
): Promise<ReportView> {
    const res = await fetchExpresso(`/apiv2/events/${eventId}/report-views`, {
        method: 'POST',
        body: input,
    });

    if (!res.ok) {
        const error = (await res.json().catch(() => null)) as { message?: string } | null;
        throw new Error(error?.message || 'Failed to create report view');
    }

    const data = (await res.json()) as { view: ReportView };
    return data.view;
}
